import React, { useContext, useEffect } from "react";
import { AiOutlineCaretDown, AiFillCaretUp } from "react-icons/ai";
import ParameterContext from "../context/parameter/parameterContext";
import CryptoContext from "../context/crypto/cryptoContext";

const Home = ({ history, location }) => {
  const {
    order,

    sortNormally,
  } = useContext(CryptoContext);
  const { setColumnName, columnName } = useContext(ParameterContext);

  // const [openBuy, setOpenBuy] = useState(false);

  // const currencySymbol = getSymbolFromCurrency(localCurrency!==convt?localCurrency:convt);

  // const currencySymbol = getSymbolFromCurrency(localCurrency!==convt?localCurrency:convt);

  useEffect(() => {
    sortNormally();
    setColumnName(null);
    //eslint-disable-next-line
  }, []);
  // useEffect(() => {
  //   console.log(livePriceData, new Date());
  // }, [livePriceData]);
  return (
    <table className="Home__MainTable" style={{ overflow: "hidden" }}>
      <thead>
        <tr>
          <th></th>
          <th style={{ textAlign: "left" }}>
            <div className="Home__MainTable-th">
              <div
                style={{
                  color: "white",
                }}
                className="Home__MainTable__pct"
              >
                {columnName && columnName === "rank" && order === 1 ? (
                  <AiFillCaretUp className="Home__MainTable__pcticon" />
                ) : columnName && columnName === "rank" && order === 0 ? (
                  <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                ) : (
                  <></>
                )}
                &nbsp;
                <div style={{ cursor: "pointer" }}>#</div>
              </div>
            </div>
          </th>
          <th style={{ textAlign: "left" }}>
            <div className="Home__MainTable-th" style={{ maxWidth: "200px" }}>
              <div
                style={{
                  color: "white",
                }}
                className="Home__MainTable__pct"
              >
                {columnName && columnName === "name" && order === 1 ? (
                  <AiFillCaretUp className="Home__MainTable__pcticon" />
                ) : columnName && columnName === "name" && order === 0 ? (
                  <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                ) : (
                  <></>
                )}
                &nbsp;
                <div style={{ cursor: "pointer" }}>Name</div>
              </div>
            </div>
          </th>
          <th style={{ textAlign: "right" }}>
            <div
              className="Home__MainTable-th"
              style={{ justifyContent: "flex-end" }}
            >
              <div
                style={{
                  color: "white",
                }}
                className="Home__MainTable__pct"
              >
                {columnName && columnName === "price" && order === 1 ? (
                  <AiFillCaretUp className="Home__MainTable__pcticon" />
                ) : columnName && columnName === "price" && order === 0 ? (
                  <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                ) : (
                  <></>
                )}
                &nbsp;
                <div style={{ cursor: "pointer" }}>Price</div>
              </div>
            </div>
          </th>
          <th style={{ textAlign: "right" }}>
            <div
              className="Home__MainTable-th"
              style={{ justifyContent: "flex-end" }}
            >
              <div
                style={{
                  color: "white",
                }}
                className="Home__MainTable__pct"
              >
                {columnName && columnName === "24h%" && order === 1 ? (
                  <AiFillCaretUp className="Home__MainTable__pcticon" />
                ) : columnName && columnName === "24h%" && order === 0 ? (
                  <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                ) : (
                  <></>
                )}
                &nbsp;
                <div style={{ cursor: "pointer" }}>24h %</div>
              </div>
            </div>
          </th>
          <th style={{ textAlign: "right" }}>
            <div
              className="Home__MainTable-th"
              style={{ justifyContent: "flex-end" }}
            >
              <div
                style={{
                  color: "white",
                }}
                className="Home__MainTable__pct"
              >
                {columnName && columnName === "7d%" && order === 1 ? (
                  <AiFillCaretUp className="Home__MainTable__pcticon" />
                ) : columnName && columnName === "7d%" && order === 0 ? (
                  <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                ) : (
                  <></>
                )}
                &nbsp;
                <div style={{ cursor: "pointer" }}>7d%</div>
              </div>
            </div>
          </th>
          <th style={{ textAlign: "right" }}>
            <div
              className="Home__MainTable-th"
              style={{ justifyContent: "flex-end" }}
            >
              <div
                style={{
                  color: "white",
                }}
                className="Home__MainTable__pct"
              >
                {columnName && columnName === "marketcap" && order === 1 ? (
                  <AiFillCaretUp className="Home__MainTable__pcticon" />
                ) : columnName && columnName === "marketcap" && order === 0 ? (
                  <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                ) : (
                  <></>
                )}
                &nbsp;
                <div style={{ cursor: "pointer" }}>Market Cap</div>
              </div>
            </div>
          </th>
          <th style={{ textAlign: "right" }}>
            <div
              className="Home__MainTable-th"
              style={{ justifyContent: "flex-end", maxWidth: "160px" }}
            >
              <div
                style={{
                  color: "white",
                }}
                className="Home__MainTable__pct"
              >
                {columnName && columnName === "volumeIn24h" && order === 1 ? (
                  <AiFillCaretUp className="Home__MainTable__pcticon" />
                ) : columnName &&
                  columnName === "volumeIn24h" &&
                  order === 0 ? (
                  <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                ) : (
                  <></>
                )}
                &nbsp;
                <div style={{ cursor: "pointer" }}>Volume(24h)</div>
              </div>
            </div>
          </th>
          <th style={{ textAlign: "right", paddingRight: "20px" }}>
            <div
              className="Home__MainTable-th"
              style={{ justifyContent: "flex-end" }}
            >
              <div>
                <p>Last 7 days</p>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {[...Array(20).keys()].map((c, index) => (
          <>
            <tr key={index} className="Home__MainTable__link">
              <td style={{ textAlign: "left", width: "50px" }}>
                <div className="Home__MainTable-td">
                  <div className="skeleton text" />
                </div>
              </td>

              <td style={{ textAlign: "left" }}>
                <div className="Home__MainTable-td">
                  <div className="skeleton text" />
                </div>
              </td>

              <td style={{ textAlign: "left", width: "300px" }}>
                <div
                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                  style={{ justifyContent: "space-between" }}
                >
                  <div
                    className="skeleton avatar"
                    style={{
                      width: "30px",
                      height: "30px",
                      marginRight: "5px",
                    }}
                  />
                  <div className="skeleton text" style={{ width: "50px" }} />
                  <div className="skeleton text" style={{ width: "120px" }} />
                  <div className="skeleton text" style={{ width: "60px" }} />
                  <div className="shimmer-wrapper">
                    <div className="shimmer"></div>
                  </div>
                </div>
              </td>

              <td style={{ textAlign: "left" }}>
                <div
                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                  style={{
                    textAlign: "left",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="skeleton text" style={{ width: "100px" }} />
                  <div className="shimmer-wrapper">
                    <div className="shimmer"></div>
                  </div>
                </div>
              </td>

              <td style={{ textAlign: "left" }}>
                <div
                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                  style={{
                    textAlign: "left",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="skeleton text" style={{ width: "60px" }} />
                  <div className="shimmer-wrapper">
                    <div className="shimmer"></div>
                  </div>
                </div>
              </td>

              <td style={{ textAlign: "left" }}>
                <div
                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                  style={{
                    textAlign: "left",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="skeleton text" style={{ width: "60px" }} />
                  <div className="shimmer-wrapper">
                    <div className="shimmer"></div>
                  </div>
                </div>
              </td>

              <td style={{ textAlign: "left" }}>
                <div
                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                  style={{
                    alignItems: "flex-end",
                    flexDirection: "column",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                  }}
                >
                  <div className="skeleton text" style={{ width: "100px" }} />
                  <div className="skeleton text" style={{ width: "60px" }} />
                  <div className="shimmer-wrapper">
                    <div className="shimmer"></div>
                  </div>
                </div>
              </td>

              <td style={{ textAlign: "left" }}>
                <div
                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                  style={{
                    alignItems: "flex-end",
                    flexDirection: "column",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                  }}
                >
                  <div className="skeleton text" style={{ width: "100px" }} />
                  <div className="skeleton text" style={{ width: "60px" }} />
                  <div className="shimmer-wrapper">
                    <div className="shimmer"></div>
                  </div>
                </div>
              </td>

              <td style={{ paddingLeft: "20px", cursor: "pointer" }}>
                <div
                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                  style={{
                    alignItems: "flex-end",
                    flexDirection: "column",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className="skeleton text"
                    style={{ width: "130px", height: "40px" }}
                  />
                  <div className="shimmer-wrapper">
                    <div className="shimmer"></div>
                  </div>
                </div>

                {/*</span>  <span className="Home__MainTable__row-name"> */}
              </td>
            </tr>
          </>
        ))}
      </tbody>
    </table>
  );
};

export default Home;
